<template>
  <div class="aplied-nutrients" ref="baseDressingNutrients">
    <!-- <pre>
      {{value.data}}
    </pre> -->
    <div class="main-title">
      {{$ml.get(`Nutrient applied per field`)}}
    </div>
    <app-loading :loading="loading">
      <div class="table-scroller" :class="{blur : (!$store.getters['user/data'].subsPlan)}">
        <app-btn to="/dashboard/plans" class="go-to-plans" v-if="!$store.getters['user/data'].subsPlan">{{$ml.get(`Get the full access to the software`)}}</app-btn>

        <table class="a-table">
          <tr class="head">
            <td>{{$ml.get(`Nutrient`)}}</td>
            <td>{{$ml.get(`Actual requirement, `)}} {{$store.getters['unit/getLabel']('kg')}}</td>
            <td>{{$ml.get(`Fertilizer contribution, `)}} {{$store.getters['unit/getLabel']('kg')}}</td>
            <td>{{$ml.get(`Fulfilled Requirement (%)`)}}</td>
          </tr>

          <tr
            v-for="n in $store.getters['nutrients/topLevelNutrients']"
            v-if="(value.data.NeededAddition[n.label+'_Val'] && (value.data.NeededAddition[n.label+'_Val']).toFixed(2) > 0)
                  || (value.data.FertAddition[n.label+'_Val'] && (value.data.FertAddition[n.label+'_Val']).toFixed(2) > 0)
                  || (value.data.Accuracy[n.label+'_Val'] && (value.data.Accuracy[n.label+'_Val']).toFixed(2) > 0)"
          >
            <td class="row-name">{{ n.label }}</td>

            <td>{{$store.getters['unit/convert']('kg', value.data.NeededAddition[n.label+'_Val'])}}</td>

            <td>{{$store.getters['unit/convert']('kg', value.data.FertAddition[n.label+'_Val'])}}</td>

            <td
              v-if="$store.getters['unit/convert']('kg', value.data.NeededAddition[n.label+'_Val']) != 0"
            >
              {{ (value.data.Accuracy[n.label+'_Val']).toFixed(2) }}
            </td>
            <td v-else>-</td>

          </tr>


          <tr v-if="(value.data.NeededAddition['CL_Val'] && (value.data.NeededAddition['CL_Val']).toFixed(2) > 0)
                || (value.data.FertAddition['CL_Val'] && (value.data.FertAddition['CL_Val']).toFixed(2) > 0)
                || (value.data.Accuracy['CL_Val'] && (value.data.Accuracy['CL_Val']).toFixed(2) > 0)"
          >
            <td class="row-name">Cl</td>

            <td>{{$store.getters['unit/convert']('kg', value.data.NeededAddition['CL_Val'])}}</td>
            <td>{{$store.getters['unit/convert']('kg', value.data.FertAddition['CL_Val'])}}</td>

            <td
              v-if="$store.getters['unit/convert']('kg', value.data.NeededAddition['CL_Val']) != 0"
            >
              {{ (value.data.Accuracy['CL_Val']).toFixed(2) }}
            </td>
            <td v-else>-</td>
            
          </tr>

        </table>
      </div>
    </app-loading>

    <!-- <div class="button-container">
      <app-btn @click="$store.dispatch('program/goToPrevStep');" class="margin-around">{{ $ml.get(`Previous`) }}</app-btn>
      <app-btn
        @click="$store.dispatch('program/goToNextStep')"
        class="next"
      >{{ $ml.get(`next`) }}</app-btn>
    </div> -->
    <!-- RESULT : {{ value }} -->
  </div>
</template>

<script>
import API from '@/api'
export default {
  props : {
    value : {
      required : false,
    },
    loading: Boolean
  },
  watch: {
    value: function (val) {
      setTimeout(() => {
        if (this.$refs.baseDressingNutrients) {
          this.$refs.baseDressingNutrients.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'center'});
        }
      }, 100);
    }
  },
}
</script>

<style lang="scss" scoped>

.aplied-nutrients {

  // padding: 0 48px;
  padding-top: 40px;

  .main-title {
    font-size: 22px;
    padding-bottom: 20px;
    font-weight: bold;
  }

  .table-scroller {
    width: 100%;
    overflow-x: auto;
  }

  table {
    width: 100%;
    .row-name {
      font-size: 13px;
    }
    .full {
      font-weight: bold;
    }
  }

  .button-container {
    margin-top: 32px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .prev {

    }

    .next {
      // margin-left: 15px;
    }

  }
}

</style>
